import { FC, useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { RxDotFilled } from 'react-icons/rx';

import ListMenu from './ListMenu';
import { RenderIcons } from './RenderIcons';
import { MenuConfig } from 'alurkerja-ui';
import checkStringInAoO from '@/utils/functions/checkStringInAoO';

const MenuWithSub: FC<{
  currentPathName?: string;
  toggled: boolean;
  menu: MenuConfig;
  menuWrapper?: ({
    children,
    menu,
    toggled,
  }: {
    children: JSX.Element;
    menu: MenuConfig;
    toggled: boolean;
  }) => JSX.Element;
  isChildren?: boolean;
}> = ({ menu, toggled, currentPathName, menuWrapper, isChildren }) => {
  const [showSub, setShowSub] = useState(false);

  const isSubActive = useMemo(() => {
    if (currentPathName) return checkStringInAoO(menu, 'href', currentPathName);
  }, [currentPathName, menu]);

  useEffect(() => {
    if (isSubActive) {
      setShowSub(true);
    }
  }, [isSubActive]);

  return (
    <>
      <div
        className={clsx(
          'cursor-pointer font-medium px-4 rounded-md flex items-center justify-between w-full whitespace-nowrap gap-x-2 mb-2 text-sm h-10',
        )}
        onClick={() => setShowSub(prev => !prev)}
      >
        <div
          className={clsx(
            'flex items-center h-full w-full gap-x-2 rounded-lg px-3 hover:bg-[#ECF0F7] dark:hover:bg-gray-700',
            currentPathName && menu.href && currentPathName.startsWith(menu.href)
              ? 'text-[#004EEB] bg-[#ECF0F7] dark:text-blue-400 dark:bg-gray-700'
              : 'text-[#5E5E5E] dark:text-gray-300',
          )}
        >
          {(!isChildren || toggled) && (
            <span className="text-sm flex-none">
              <RenderIcons icon={menu.icon} fallback={<RxDotFilled />}></RenderIcons>
            </span>
          )}
          {!toggled && <span className="flex-1 whitespace-normal">{menu.label}</span>}
          <div className="ml-auto flex-none">{!toggled && showSub ? <HiChevronUp /> : <HiChevronDown />}</div>
        </div>
      </div>
      {showSub && menu.child && (
        <div className={clsx('text-xs border-l dark:border-gray-700', toggled ? 'ml-0' : 'ml-[35px]')}>
          <ListMenu
            menuConfig={menu.child}
            toggled={toggled}
            menuWrapper={menuWrapper}
            currentPathName={currentPathName}
            isChildren
          />
        </div>
      )}
    </>
  );
};

export default MenuWithSub;
